import React from "react";
import { Copy, ExternalLink, MessageCircle } from "lucide-react";
import { dmMessage, guideUrl, guideSlug } from "../../lib/studioApi";

const btn = "inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-[10px] font-black uppercase tracking-widest border transition-colors";

export const DmReplyKit = ({ region, keyword, notify, status, scope = "guide", compact = false }) => {
  const id = `${scope}-${guideSlug(region)}`;
  const copy = async () => {
    await navigator.clipboard.writeText(dmMessage(region));
    notify(`${region} DM reply copied — paste it into Instagram`);
  };
  return (
    <div data-testid={`dm-kit-${id}`} className={`flex items-center gap-2 flex-wrap ${compact ? "" : "rounded-xl border border-zinc-800 bg-zinc-900/60 px-3 py-2"}`}>
      <MessageCircle className="w-3.5 h-3.5 text-[#BEFF38] shrink-0" />
      <span className="text-[11px] text-zinc-300">
        DM reply <span className="font-mono text-[#BEFF38]">{keyword || region.toUpperCase()}</span>
        {status && status !== "ready" && <span data-testid={`dm-kit-status-${id}`} className="ml-1 text-zinc-500">· {status === "building" ? "writing guide…" : status}</span>}
      </span>
      <button onClick={copy} data-testid={`dm-kit-copy-${id}`} className={`${btn} ml-auto bg-[#BEFF38] border-[#BEFF38] text-black hover:bg-[#a8e62e]`}>
        <Copy className="w-3 h-3" /> Copy DM
      </button>
      <a href={guideUrl(region)} target="_blank" rel="noreferrer" data-testid={`dm-kit-open-${id}`} className={`${btn} border-zinc-700 text-zinc-300 hover:border-[#BEFF38] hover:text-white`}>
        <ExternalLink className="w-3 h-3" /> PDF
      </a>
    </div>
  );
};
